import { useState } from 'react';

export const useModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    confirmText: 'OK',
    onConfirm: null,
    showCancel: false,
    cancelText: 'Cancelar',
    onCancel: null,
    inputType: null,      
    inputValue: '',       
    onInputChange: null,  
  });

  const showModal = ({
    type = 'info',
    title,
    message,
    confirmText = 'OK',
    onConfirm,
    showCancel = false,
    cancelText = 'Cancelar',
    onCancel
  }) => {
    setModalState({
      isOpen: true,
      type,
      title,
      message,
      confirmText,
      onConfirm,
      showCancel,
      cancelText,
      onCancel
    });
  };

  const hideModal = () => {
    setModalState(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const showSuccess = (title, message, onConfirm) => {
    return new Promise((resolve) => {
      const done = () => {
        onConfirm?.();
        resolve(true);
      };
      showModal({
        type: 'success',
        title,
        message,
        onConfirm: done,
        onCancel: done,
      });
    });
  };

  const showError = (title, message, onConfirm) => {
    return new Promise((resolve) => {
      const done = () => {
        onConfirm?.();
        resolve(true);
      };
      showModal({
        type: 'error',
        title,
        message,
        onConfirm: done,
        onCancel: done,
      });
    });
  };

  const showWarning = (title, message, onConfirm) => {
    return new Promise((resolve) => {
      const done = () => {
        onConfirm?.();
        resolve(true);
      };
      showModal({
        type: 'warning',
        title,
        message,
        confirmText: 'Continuar',
        onConfirm: done,
        onCancel: done,
      });
    });
  };

  const showInfo = (title, message, onConfirm) => {
    return new Promise((resolve) => {
      const done = () => {
        onConfirm?.();
        resolve(true);
      };
      showModal({
        type: 'info',
        title,
        message,
        onConfirm: done,
        onCancel: done,
      });
    });
  };

  const showConfirm = (title, message) => {
    return new Promise((resolve) => {
      showModal({
        type: 'warning',
        title,
        message,
        confirmText: 'Confirmar',
        showCancel: true,
        cancelText: 'Cancelar',
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  };

  const showLoading = (title = 'Carregando...', message = 'Aguarde') => {
    showModal({
      type: 'loading',
      title,
      message,
      showCancel: false,
      confirmText: '',
      onConfirm: null
    });
  };

   // Novo método: confirmação com textarea
   const showEditConfirm = (title, message) => {
    return new Promise((resolve) => {
      showModal({
        type: "warning",
        title,
        message,
        inputType: "textarea",
        inputValue: "", // inicial
        onInputChange: (value) => {
          setModalState((prev) => ({
            ...prev,
            inputValue: value
          }));
        },
        confirmText: "Confirmar",
        showCancel: true,
        cancelText: "Cancelar",
        onConfirm: () => resolve(modalState.inputValue || null),
        onCancel: () => resolve(null),
      });
    });
  };
  
  return {
    modalState,
    showModal,
    hideModal,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm,
    showLoading,
    showEditConfirm,
  };
};


